export default "__VITE_ASSET__9F4A3rkZ__"